/** Splits a byte-stream's text into lines on CR, LF or CR LF; an ACK byte (06h) is a line of its own. */
export const ACK = "\u0006";
const MAX_LINE_LENGTH = 512;

export interface LineSplitter {
  push: (chunk: string) => void;
  flush: () => void;
  /** Drops the partial line, e.g. after a framing or parity error lost a byte of it. */
  discard: () => void;
}

export function createLineSplitter(onLine: (line: string) => void): LineSplitter {
  let buffer = "";
  return {
    push(chunk) {
      for (const char of chunk) {
        if (char === "\r" || char === "\n") {
          if (buffer.length) onLine(buffer);
          buffer = "";
        } else if (char === ACK) {
          onLine(ACK);
        } else {
          buffer += char;
          if (buffer.length > MAX_LINE_LENGTH) buffer = buffer.slice(-MAX_LINE_LENGTH);
        }
      }
    },
    flush() {
      if (buffer.length) onLine(buffer);
      buffer = "";
    },
    discard() {
      buffer = "";
    },
  };
}
